<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div class="flex items-center">
                    <svg
                        width="24"
                        height="15"
                        viewBox="0 0 44 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.81149 6.68799H35.0321C35.0321 7.03514 35.0321 7.35853 35.0321 7.68193C35.0321 15.2315 35.0321 22.781 35.0321 30.3306C35.0321 33.1005 33.2123 34.9477 30.4224 34.9879C28.7487 35.0116 27.0751 34.9933 25.4015 34.9933C21.4458 34.9933 17.4884 34.9933 13.5327 34.9933C11.6453 34.9933 10.1398 34.2826 9.29201 32.5432C9.00881 31.9622 8.79869 31.277 8.79504 30.6375C8.76215 22.845 8.77311 15.0543 8.77494 7.2617C8.77494 7.0863 8.79687 6.91089 8.81149 6.68799V6.68799ZM21.7802 24.1057C23.1779 24.1112 24.5026 23.7823 25.6518 23.1739C29.0356 21.3815 29.4905 17.1499 26.5635 14.6907C24.1938 12.6991 19.7868 12.6571 17.3787 14.603C14.2946 17.0951 14.7587 21.4235 18.2959 23.2323C19.4287 23.8115 20.6291 24.0691 21.7802 24.1057V24.1057Z"
                            fill="black"
                        />
                        <path
                            d="M21.8772 4.41133C17.0061 4.41133 12.1333 4.41133 7.26224 4.41133C6.92788 4.41133 6.58987 4.40402 6.25917 4.45153C5.07704 4.62145 4.36264 5.41806 4.34437 6.61846C4.32245 8.01436 4.34437 9.40843 4.33889 10.8043C4.33341 12.2313 3.53497 13.1028 2.22129 13.1321C0.903954 13.1613 0.0178142 12.2313 0.00685161 10.7861C-0.00228387 9.48152 -0.00228387 8.17697 0.00685161 6.87243C0.034258 2.94783 2.65431 0.258348 6.60815 0.0866008C6.75979 0.0792924 6.91327 0.082943 7.06492 0.082943C16.9605 0.082943 26.8578 0.0792924 36.7534 0.0866008C38.0104 0.0866008 39.2419 0.249208 40.3692 0.87042C42.5526 2.07448 43.6854 3.9436 43.7895 6.40104C43.8553 7.94493 43.8206 9.49431 43.7987 11.0419C43.7822 12.2569 42.9418 13.0772 41.7213 13.1302C40.5135 13.1832 39.5233 12.3227 39.4831 11.0948C39.4374 9.73183 39.4118 8.36151 39.4867 7.00033C39.5781 5.3395 38.5896 4.38575 36.8594 4.39854C31.8659 4.43325 26.8724 4.41133 21.879 4.41133H21.8772Z"
                            fill="black"
                        />
                    </svg>

                    <h2 class="font-bold text-xl leading-tight ml-2">Saques</h2>
                </div>
                <balance :short="true" />
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <menu-cripto />
                <balance-crypto class="mb-5 w-full mt-6" />
                <div class="flex justify-between mt-8">
                    <h2 class="text-black text-opacity-70 text-xl font-bold">
                        Saque de cripto
                    </h2>
                    <withdraw-modal :available="available" :cryptos="cryptos" />
                </div>

                <div class="bg-white shadow-md sm:rounded-lg p-6 mt-6">
                    <flash :timeout="5000" />
                    <div
                        class="flex justify-between items-center -mb-12 mt-5 pr-28"
                    >
                        <h2
                            class="font-bold text-xl text-gray-800 leading-tight"
                        >
                            Lista de saques
                        </h2>
                        <date-filter
                            v-show="false"
                            :buttons="buttonsFilter"
                            :filter="$page.props.queryString.interval"
                        />
                    </div>
                    <inertia-table
                        parent="crypto"
                        routeName="withdraw.index"
                        :data="withdrawals"
                        :params="params"
                        :enableSearch="false"
                        :filters="filters"
                        :enable-pages="true"
                        :enable-display="true"
                        :columns="columns"
                        :hasLine="false"
                        :enableExport="false"
                        :hasIcon="false"
                        :icon="false"
                    >
                        <template slot-scope="{ item }" slot="coin">
                            <span class="text-sm font-bold text-gray-700">
                                {{ item.dest_wallet.name }}
                            </span>
                            <div class="flex items-center gap-x-3 mr-3">
                                <span class="text-sm">
                                    <span class="text-xs text-gray-600">Moeda:</span>
                                    {{ returnNameOfCurrency(item.coin) }}
                                </span>
                                <span class="text-sm">
                                    <span class="text-xs text-gray-600">Rede:</span>
                                    {{ item.dest_wallet.network }}
                                </span>
                            </div>
                        </template>
                        <template slot-scope="row" slot="crypto_amount">
                            <div class="text-black text-sm">
                                {{
                                    `${numberFormat(
                                        row.item.crypto_amount,
                                        row.item.coin
                                    )} ${row.item.coin}`
                                }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="fee">
                            <div class="text-black text-sm">
                                1.555
                            </div>
                        </template>
                        <template slot-scope="row" slot="created">
                            <div class="text-gray-500">
                                {{ moment(row.item.created).format("DD/MM/YYYY HH:mm") }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="status">
                            <div
                                class="inline-block rounded-full px-3 py-1"
                                :class="getStatusWithdraw(row.item.status).class"
                            >
                                {{ getStatusWithdraw(row.item.status || "pending").text }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="updated">
                            <div class="text-gray-500">
                                {{
                                    row.item.updated
                                        ? moment(row.item.updated).format("DD/MM/YYYY HH:mm")
                                        : "--/--/----"
                                }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="int_balance">
                            <div class="text-gray-500 font-semibold">
                                {{
                                    `${numberFormat(
                                        row.item.balance,
                                        row.item.coin
                                    )} ${row.item.coin}`
                                }}
                            </div>
                        </template>
                        <template slot-scope="{ item }" slot="link">
                            <a
                                v-tippy="
                                    item?.transaction?.uri
                                        ? 'Abrir link'
                                        : 'Pendente'
                                "
                                class="flex items-center justify-center rounded-full border border-gray-300 w-9 h-9"
                                :class="
                                    item?.transaction?.uri
                                        ? 'bg-white text-black cursor-pointer'
                                        : 'bg-gray-200 text-gray-400'
                                "
                                :href="item?.transaction?.uri"
                                target="_blank"
                            >
                                <i class="fas fa-receipt" />
                            </a>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout";
import Flash from "../../../Helpers/Flash";
import InertiaTable from "../../../Helpers/Tables/InertiaTable.vue";
import numberFormat from "../utils/numberFormat";
import icons from "../utils/icons";
import moment from "moment";
import WithdrawModal from "./WithdrawModal.vue";
import BalanceCrypto from "../Balance.vue";
import Balance from "../../../Helpers/Balance.vue";
import MenuCripto from "../components/MenuCripto.vue";
import DateFilter from "../../../Helpers/Tables/DateFilter.vue";

export default {
    props: ["withdrawals", "available"],
    components: {
        AppLayout,
        Flash,
        InertiaTable,
        WithdrawModal,
        BalanceCrypto,
        Balance,
        MenuCripto,
        DateFilter,
    },
    data() {
        return {
            icons,
            moment,
            numberFormat,
            cryptos: [],
            buttonsFilter: [
                { name: "Hoje", key: "today" },
                { name: "Ontem", key: "yesterday" },
                { name: "Esta semana", key: "week" },
                { name: "Este mês", key: "month" }
            ],
            columns: [
                {
                    text: "Wallet",
                    className: "text-left",
                    key: "coin",
                    sortable: true
                },
                {
                    text: "Quantidade",
                    className: "text-left",
                    key: "crypto_amount",
                    sortable: true
                },
                // {
                //     text: "Taxa",
                //     className: "text-left",
                //     key: "fee",
                //     sortable: true
                // },
                {
                    text: "Status",
                    className: "text-left",
                    key: "status",
                    sortable: false
                },
                {
                    text: "Data da solicitação",
                    className: "text-left",
                    key: "created",
                    sortable: true
                },
                {
                    text: "Data da conclusão",
                    className: "text-left",
                    key: "updated",
                    sortable: true
                },
                {
                    text: "",
                    className: "text-left",
                    key: "link",
                    sortable: false
                }
            ],
            filters: [
                {
                    text: "Moeda",
                    key: "coin",
                    type: "dropdown",
                    options: [],
                    colSpan: 2
                },
                {
                    text: "Carteira",
                    key: "wallet_name",
                    type: "text",
                    colSpan: 2
                },
                {
                    text: "Rede",
                    key: "network",
                    type: "dropdown",
                    options: [
                        { id: "ERC-20", name: "ERC-20" },
                        { id: "TRC-20", name: "TRC-20" },
                        { id: "Polygon", name: "Polygon" },
                        { id: "BEP20", name: "BEP20" },
                        { id: "BTC", name: "BTC" }
                    ],
                    colSpan: 2
                },
                {
                    text: "Quantidade",
                    key: "amount",
                    type: "number_interval",
                    colSpan: 2,
                    isPrecision: false
                },
                {
                    text: "Saldo",
                    key: "balance",
                    type: "number_interval",
                    colSpan: 2,
                    isPrecision: false
                },
                {
                    text: "Status",
                    key: "status",
                    type: "dropdown",
                    options: [
                        { id: "pending", name: "Pendente" },
                        { id: "finished", name: "Finalizado" },
                        { id: "canceled", name: "Cancelado" }
                    ],
                    colSpan: 2
                },
                {
                    text: "Data da solicitação",
                    key: "request_date",
                    type: "date_interval2",
                    colSpan: 2,
                    hasTime: false
                },
                {
                    text: "Data do envio",
                    key: "send_date",
                    type: "date_interval2",
                    colSpan: 2,
                    hasTime: false
                }
            ],
            params: {
                sort: "created:desc",
                page: 1,
                ...this.$page.props.queryString
            }
        };
    },
    methods: {
        async getCurrencies() {
            const { data } = await axios.get("/crypto/currencies");
            this.cryptos = data.list;
            this.filters[0].options = this.cryptos
                .filter(currency => currency.status === "active")
                .map(currency => ({
                    ...currency,
                    name: currency.coin,
                    id: currency.id.toUpperCase()
                }));
        },
        getStatusWithdraw(status) {
            switch (status.toLowerCase()) {
                case "pending":
                    return {
                        text: "Pendente",
                        class: "bg-yellow-500 text-white"
                    };
                case "finished":
                    return {
                        text: "Concluído",
                        class: "bg-green-500 text-white"
                    };
                case "canceled":
                    return { text: "Recusado", class: "bg-red-500 text-white" };
                default:
                    return { text: "Aguardando confirmação da rede" };
            }
        },
        returnNameOfCurrency(name = "BTC") {
            return this.cryptos.find(({ coin }) => coin === name)?.name ?? name;
        },
    },
    created() {
        this.getCurrencies();
    }
};
</script>
